// extracted by mini-css-extract-plugin
export default {"options":"BiopharmaGroupsFilterOptions-module__options___ukdGI"};